import React from "react";
import Follow from "../../components/Follow";
import Layout from "../Layouts/Layout";
import CardProduct from "components/CardProduct";
import Banner from "components/BannerHeader";

const Novidades = () => {
  return (
    <Layout colorMenu={"#fff"}>
      <Banner imgBanner="" title="New in" description=""/>
      <CardProduct filters="novidades"/>
      <Follow />
    </Layout>
  );
};

export default Novidades;
